<template>
  <div class="content">
    <div class="content_wrap">
      <div class="content_crumbs">
        <el-breadcrumb separator-icon="ArrowRight">
          <el-breadcrumb-item :to="{ path: '/' }"> 当前位置：首页</el-breadcrumb-item>
          <el-breadcrumb-item>信息</el-breadcrumb-item>
          <el-breadcrumb-item>正文</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="content_content">
        <div class="content_content_title">
          {{ NewsArr.title }}
        </div>

        <div class="content_content_crumbs" :style="fixedPosition">
          <div class="content_content_crumbs_time">
            <img :src="contentCrumbs.timeIcon" />
            发布时间：{{ NewsArr.publishTime }}
            阅读次数：{{ NewsArr.readingTimes }}
          </div>
        </div>

        <div v-if="NewsArr.fileList" style="padding: 20px;" v-for="item in NewsArr.fileList" :key="item.aulId">
          <a :href="'/sino/api/cms/tenderBulletin/download' + '?attachId=' + item.aulId" style="color:black;width: 100%;display: flex;justify-content:center;text-decoration: none;">
            <img style="margin-right: 10px;width: 16px;" src="@/static/common/xz.png" />
            <div>{{item.oldName}}</div>
          </a>
        </div>

        <div class="content_content_item_wrap">

          <div class="content_content_item">
            <p v-html="NewsArr.content"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  computed,
  reactive,
  onMounted,
  onBeforeMount,
  ref,
  onUnmounted,
} from "vue";
import imgData from "@/data";
import { stateStore, mainStore } from "@/store";
import { storeToRefs } from "pinia";
import { useRouter, useRoute } from "vue-router";
import allUrl from "@/config/url.js";
import { getById } from "@/api/index.js";
export default {
  props: ["haveFile", "haveTurner"],
  setup() {
    onBeforeMount(() => {
      window.addEventListener("scroll", () => {
        stateStore().setscrollX(document.documentElement.scrollTop);
      });
      const route = useRoute();
      stateStore().selectArticleById(route.query.id);
    });
    onUnmounted(() => {
      window.removeEventListener("scroll", () => {
        console.log("remove");
      });
    });
    const fixedPosition = computed(() =>
      storeToRefs(stateStore()).scrollX.value > 400
        ? "position: fixed;top:0;right: 16%;width: 68%;"
        : ""
    );
    const router = useRouter();
    const storeOfstate = stateStore();
    const content = computed(() => {
      return storeToRefs(storeOfstate).activeHtml;
    });
    const contentTitle = computed(() => {
      return storeToRefs(storeOfstate).activeTitle;
    });
    const publishTime = computed(
      () => storeToRefs(storeOfstate).activePublishTime
    );
    const ActiveItem = computed(() => storeToRefs(storeOfstate).activeItem);
    const activeAttachList = computed(
      () => storeToRefs(storeOfstate).activeAttachList
    );
    const goHistory = () => {
      router.go(-1);
    };
    const toHref = (item) => {
      // window.open(location.origin + "/" + url);
      const a = document.createElement("a");
      a.href = location.origin + "/" + item.name;
      a.download = item.originalName;
      a.click();
    };
    const goToJoin = () => {
      window.open(allUrl.ServicePlatform);
    };
    const goIndex = () => {
      mainStore().setactivePageUrl("/index");
      router.push({
        path: "/index",
      });
    };
    const NewsId = ref()
    const NewsArr = ref({})
    const News = async () => {
      let res = await getById({ id: NewsId.value })
      NewsArr.value = res.data
      console.log(res, 'res');
    }
    onMounted(async () => {
      NewsId.value = router.currentRoute.value.query.id;
      await News()
    })
    const data = reactive({
      ...imgData.BiddingInfoImg,
      content,
      contentTitle,
      publishTime,
      ActiveItem,
      activeAttachList,
    });

    return {
      ...data,
      goHistory,
      goToJoin,
      goIndex,
      fixedPosition,
      toHref,
      NewsArr,
      News,
    };
  },
  methods: {
    getLink(link) {
      return '/onlineS/' + link
    },
  }
};
</script>

<style scoped>
@import url("./Content.css");
</style>

